module.exports = __webpack_public_path__ + "static/media/18.689c475f.jpg";